module.exports = {
	"apiUrl": "https://l.unigine.com/api/v1",
	"baseUrl": "https://l.unigine.com",
	"apiCrmAnalyticsUrl": "https://crm.unigine.com/analytics/api",
	"apiIdUrl": "https://id.unigine.com/api/v1",
	"siteFpUrl": "https://fp.unigine.com",
	"apiFpUrl": "https://fp.unigine.com/api/v1",
	"siteUnigineUrl": "https://unigine.com",
	"env": "production"
};


//////////////////
// WEBPACK FOOTER
// ./src/config/common.json
// module id = 141
// module chunks = 0